module.exports = __webpack_public_path__ + "static/img/30006 (1).1cc1baf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30006 (1).webp
// module id = dFjV
// module chunks = 14